export default __webpack_public_path__ + "assets/images/166e942c1479b5a121770728f414fb64.svg";